<template>
  <!-- «Первые шаги» — карточка новичка вверху дня (решение владельца
       26.10.2026): пять дел, которые показывают, что умеет дневник. Прогресс
       считает сервер из данных (api/guide.js), не хранится отдельно. Живёт 7
       дней с регистрации или пока не сделано всё; крестик закрывает навсегда.
       Свёрнута по умолчанию — заголовок со счётом и только следующий шаг
       (место на экране, замечание владельца 26.10.2026); тап по заголовку
       раскрывает все пять. -->
  <div class="fs-card">
    <div class="fs-head">
      <button type="button" class="fs-cap" :aria-expanded="open" @click="open = !open">
        <span class="fs-title">Первые шаги</span>
        <span class="fs-count">{{ done }} из {{ items.length }}</span>
        <svg class="fs-chev" :class="{ 'is-open': open }" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <button type="button" class="fs-close" aria-label="Скрыть" @click="guide.closeChecklist()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <button
      v-for="it in shown"
      :key="it.key"
      type="button"
      class="fs-row"
      :class="{ 'is-done': it.done }"
      @click="go(it.key)"
    >
      <span class="fs-check" aria-hidden="true">
        <svg v-if="it.done" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M1 5.2 4.3 8.5 11 1.5" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
      <span class="fs-label">{{ it.label }}</span>
      <svg v-if="!it.done" class="fs-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import guide, { state, checklistDone, CHECKLIST_ITEMS } from '../services/guide.js'

const emit = defineEmits(['go'])

const LABELS = {
  photo:   'Добавить блюдо по фото',
  edit:    'Поправить вес или продукт',
  repeat:  'Повторить блюдо',
  week:    'Посмотреть неделю',
  profile: 'Рассказать о себе: рост, вес, возраст, цели',
}

const open = ref(false)
const items = computed(() => CHECKLIST_ITEMS.map(key => ({
  key,
  label: LABELS[key],
  done: !!state.checklist.items?.[key],
})))
// Свёрнуто — только первый несделанный шаг (все сделаны — карточки нет)
const shown = computed(() => open.value ? items.value : items.value.filter(it => !it.done).slice(0, 1))
const done = checklistDone

function go(key) {
  guide.journey('j_steps_go', { key })
  emit('go', key)
}
</script>

<style scoped>
.fs-card {
  position: relative;
  z-index: 1;                /* поверх закреплённой подсказки пустого дня (Diary.vue) */
  margin: 12px 12px 0;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 6px 10px 4px 12px;
  font-family: Inter, sans-serif;
  color: var(--ink);
}
.fs-head { display: flex; align-items: center; }
.fs-cap {
  display: flex; align-items: center; gap: 6px;
  padding: 2px 0; margin: 0;
  background: none; border: 0; color: var(--ink);
  font-family: Inter, sans-serif;
}
.fs-title { font-size: var(--fs-12); font-weight: 600; }
.fs-count { font-size: var(--fs-12); color: var(--ink-70); }
.fs-chev { color: var(--ink-60); transition: transform .18s; }
.fs-chev.is-open { transform: rotate(180deg); }
.fs-close {
  margin-left: auto;
  width: 26px; height: 26px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%; color: var(--ink-60); background: none; border: 0;
}
.fs-row {
  display: flex; align-items: center; gap: 10px;
  width: 100%; text-align: left;
  padding: 6px 2px 7px;
  border: 0;
  background: none; color: var(--ink);
  font-family: Inter, sans-serif; font-size: var(--fs-14);
}
.fs-row + .fs-row { border-top: 1px solid var(--line); }
.fs-check {
  width: 20px; height: 20px; flex: none;
  border-radius: 50%;
  border: 1.5px solid var(--sand);
  display: flex; align-items: center; justify-content: center;
  color: #fff;
}
.is-done .fs-check { background: #D6AC67; border-color: #D6AC67; }
.is-done .fs-label { color: var(--ink-60); text-decoration: line-through; text-decoration-color: var(--sand); }
.fs-label { flex: 1; min-width: 0; line-height: 1.3; }
.fs-chevron { color: var(--ink-60); flex: none; }
</style>
